export default {"src":"/_next/static/image/public/images/flags/flag_225.44a7585086ba3ddd63c2fe8e8cb43750.svg","height":16,"width":24};